<template>
  <div>
    <section class="page-content center">
      <br>
      <v-layout row wrap>    
        <v-flex xs12 sm12 lg12 v-if="company.companyConfirm && company.companyIPConfirm">
          <v-alert value="true" type="info" style="margin-bottom: 20px">Proposta confirmada em {{ transformaData(company.companyConfirm, 'DD/MM/YYYY') }} às {{ transformaData(company.companyConfirm, 'HH:mm') }} pelo IP {{ company.companyIPConfirm }}.</v-alert>
        </v-flex>

        <v-flex xs12 sm12 lg12>
          <p class="total" style="font-size:25px" v-if="confirmado">{{msmTitulo}}</p>
          <p class="total" style="color:#D64550; font-size:25px" v-else>{{msmTitulo}}</p>    
          <v-container class="resumo">
            <p style="font-size:18px" v-if="this.company.reteveAdesao == true">{{msgCorpoAdesao}}</p>
            <p style="font-size:18px" v-else>{{msgCorpo}}</p>
          </v-container>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12 style="margin-bottom: 20px" v-if="modoAssinatura == 'ZAPSIGN'" :key="verificaAssinatura">
          <v-flex xs12 sm12 lg12>
            <p class="form-titulo">Assinatura do Contrato</p>
          </v-flex>
          <v-card v-if="!company.ZSLinkAssinatura" outline height="600px" style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <v-progress-circular indeterminate color="#009b9b" size="70"></v-progress-circular>
            <p style="margin-top: 10px; font-size: 16px; font-weight: bold;">Carregando contrato...</p>
          </v-card>
          
          <iframe v-else :src="company.ZSLinkAssinatura" frameborder="0" width="100%" height="600px"></iframe>
        </v-flex>

        <v-flex xs12 sm12 md12 lg8 v-if="pdfSelecionado!='' && modoAssinatura == 'CHECKBOX'" :key="verificaAssinatura">
          <p class="total">Minutas, Manuais e Guias</p>
          <iframe v-if="this.$vuetify.breakpoint.lg" :src="`${pdfSelecionado}`" width="680" height="400" style="border: none;"></iframe>
        </v-flex>

        <v-flex xs12 sm12 md12 lg4 v-if="modoAssinatura == 'CHECKBOX'" :key="verificaAssinatura">
          <br>
          <br>
          <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
              v-if="planoSelecionado.urlContrato != '' && planoSelecionado.urlContrato != undefined"
              @click="pdfSelecionado = planoSelecionado.urlContrato" avatar
            >
              <v-list-tile-action>
                <img src="../Content/images/pdf.png" width="30px">
              </v-list-tile-action>
              <v-list-tile-title>Contrato</v-list-tile-title>
            </v-list-tile>
          </div>
          <div v-else>
            <v-list-tile
              v-if="planoSelecionado.urlMinutaContrato != '' && planoSelecionado.urlMinutaContrato != undefined"
              @click="pdfSelecionado = planoSelecionado.urlMinutaContrato" :href="planoSelecionado.urlMinutaContrato" target='_blank' avatar
            >
              <v-list-tile-action>
                <img src="../Content/images/pdf.png" width="30px">
              </v-list-tile-action>
              <v-list-tile-title>Minuta do Contrato</v-list-tile-title>
            </v-list-tile>
          </div>

          <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
              v-if="planoSelecionado.urlMinutaAditivo != '' && planoSelecionado.urlMinutaAditivo != undefined"
              @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" avatar
            >
              <v-list-tile-action>
                <img src="../Content/images/pdf.png" width="30px">
              </v-list-tile-action>
              <v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
            </v-list-tile>
          </div>
          <div v-else>
            <v-list-tile
              v-if="planoSelecionado.urlMinutaAditivo != '' && planoSelecionado.urlMinutaAditivo != undefined"
              @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" :href="planoSelecionado.urlMinutaAditivo" target='_blank' avatar
            >
              <v-list-tile-action>
                <img src="../Content/images/pdf.png" width="30px">
              </v-list-tile-action>
              <v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
            </v-list-tile>
          </div>

          <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
              v-if="planoSelecionado.urlCobertura != '' && planoSelecionado.urlCobertura != undefined"
              @click="pdfSelecionado = planoSelecionado.urlCobertura" avatar
            >
              <v-list-tile-action>
                <img src="../Content/images/pdf.png" width="30px">
              </v-list-tile-action>
              <v-list-tile-title>Cobertura do Plano</v-list-tile-title>
            </v-list-tile>
          </div>
          <div v-else>
            <v-list-tile
              v-if="planoSelecionado.urlCobertura != '' && planoSelecionado.urlCobertura != undefined"
              @click="pdfSelecionado = planoSelecionado.urlCobertura" :href="planoSelecionado.urlCobertura" target='_blank' avatar
            >
              <v-list-tile-action>
                <img src="../Content/images/pdf.png" width="30px">
              </v-list-tile-action>
              <v-list-tile-title>Cobertura do Plano</v-list-tile-title>
            </v-list-tile>
          </div>

          <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
              v-if="planoSelecionado.urlManual != '' && planoSelecionado.urlManual != undefined"
              @click="pdfSelecionado = planoSelecionado.urlManual" avatar
            >
              <v-list-tile-action>
                <img src="../Content/images/pdf.png" width="30px">
              </v-list-tile-action>
              <v-list-tile-title>Manual de Orientação</v-list-tile-title>
            </v-list-tile>
          </div>
          <div v-else>
            <v-list-tile
              v-if="planoSelecionado.urlManual != '' && planoSelecionado.urlManual != undefined"
              @click="pdfSelecionado = planoSelecionado.urlManual" :href="planoSelecionado.urlManual" target='_blank' avatar
            >
              <v-list-tile-action>
                <img src="../Content/images/pdf.png" width="30px">
              </v-list-tile-action>
              <v-list-tile-title>Manual de Orientação</v-list-tile-title>
            </v-list-tile>
          </div>

          <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
              v-if="planoSelecionado.urlGuia != '' && planoSelecionado.urlGuia != undefined"
              @click="pdfSelecionado = planoSelecionado.urlGuia" avatar
            >
              <v-list-tile-action>
                <img src="../Content/images/pdf.png" width="30px">
              </v-list-tile-action>
              <v-list-tile-title>Guia de Leitura Contratual</v-list-tile-title>
            </v-list-tile>
          </div>
          <div v-else>
            <v-list-tile
              v-if="planoSelecionado.urlGuia != '' && planoSelecionado.urlGuia != undefined"
              @click="pdfSelecionado = planoSelecionado.urlGuia" :href="planoSelecionado.urlGuia" target='_blank' avatar
            >
              <v-list-tile-action>
                <img src="../Content/images/pdf.png" width="30px">
              </v-list-tile-action>
              <v-list-tile-title>Guia de Leitura Contratual</v-list-tile-title>
            </v-list-tile>
          </div>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12 v-if="modoAssinatura == 'CHECKBOX' && company.status == 'AGUARDANDO CONFIRMAÇÃO'" :key="verificaAssinatura">
          <v-checkbox v-model="contrataccept" color="#0f75bc">
            <span slot="label">Li e concordo com os termos do contrato</span>
          </v-checkbox>
        </v-flex>

        <v-flex xs12 sm12 lg4>
          <div class="planos-wrapper" style="background:none">
            <div class="list-planos">                    
              <div class="item">
                <h6 class="form-titulo" style="text-align: center;">Plano Empresarial</h6>
                <br>
                <p class="price"><span>R$</span> {{company.responsibility}}<br></p>
                <br>
                <h6 class="desconto" style="text-align: center;">Adesão</h6>
                <a @click="aceiteProposta()" class="button" v-if="company.status == 'AGUARDANDO CONFIRMAÇÃO' && company.reteveAdesao">Aceitar Proposta</a>
                <a @click="gerarBoleto()" class="button" v-if="(company.status == 'AGUARDANDO CONFIRMAÇÃO' && !company.reteveAdesao) || company.situacaoBoleto == 'VENCIDO'">Gerar Boleto</a>
                <a @click="imprimirBoleto()" class="button" v-if="imprimir">Imprimir Boleto</a>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <br>
      <br>
      <br>
      <br> 
    </section>
    <loading
      :active.sync="isLoading" 
      :can-cancel="true" 
      color="#7593b4"
      :is-full-page="fullPage"
    ></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  import Snackbar from '../components/snackbar.vue'
  import axios from 'axios'
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl, modelBoleto } from '@/global'
  import moment from 'moment'
  export default {
    components: {Snackbar, Loading},
    data() {
      return {
        msmTitulo: 'Estamos quase lá!',
        msgCorpo: 'Para concluir a sua proposta, é necessário gerar o boleto. Para isso, basta assinar o contrato abaixo.',
        msgCorpoAdesao: 'Para concluir a sua proposta, é necessário assinar o contrato e aceitar no botão abaixo.',
        confirmado: true,
        company: [],
        boletoGerado: false,
        pdfSelecionado: '',
        planoSelecionado: '',
        contrataccept: false,
        cidade: '',
        estado: '',
        bairro: '',
        fullPage: true,  
        isLoading: false, 
        token: '',
        idBoleto: '', 
        imprimir: false,
        ipConfirm: '',
        confirmDate: '',
        verificaAssinatura: 0,
        modoAssinatura: 'CHECKBOX',
      }               
    },

    mounted : function() {
      this.verificaVersao()
      this.pegaParametrosUrl()
      this.carregaPlano()
    },

    beforeDestroy() {
      if (this.verificaAssinatura) {
        clearInterval(this.verificaAssinatura);
      }
    },

    methods: {
      async carregaPlano() {
        try {
          let res = await axios.get(`${baseApiUrl}PrecoPlanos?filter={"where":{"companyId":"${this.company.id}"},"include":"plans"}`)
          if (res.data != '') {
            this.planoSelecionado = res.data[0].plans
            this.pdfSelecionado = res.data[0].plans.urlMinutaContrato 
          }
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar plano", "ERRO");
        }
      },

      async gerarBoleto() {
        var vm = this
        if (this.contrataccept) {
          if (!this.company.proposalNumber) {
            this.company.proposalNumber = this.company.id.replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10)
          }

          this.isLoading = true
          this.token = ''
          this.idBoleto = ''
          //Criando data de vencimeto do boleto
          var datapagvenc = new Date();
          datapagvenc.setDate(new Date().getDate() + 3)
          //Preencher o campos do model de Boleto
          modelBoleto.pagadorDocumentoNumero = this.company.cnpj.replace(/[^\d]+/g,'')
          modelBoleto.pagadorNome = this.company.businessName.substr(0, 39)
          modelBoleto.pagadorEndereco = this.company.address.substr(0, 30) + ', ' + this.company.addressNumber
          modelBoleto.pagadorBairro = this.bairro.substr(0, 19)
          modelBoleto.pagadorDocumentoTipo = 2
          modelBoleto.pagadorCidade = this.cidade.substr(0, 19)
          modelBoleto.pagadorUf = this.estado 
          modelBoleto.pagadorCep = this.company.cep.replace(/[^\d]+/g,'');
          modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
          modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
          //salvando o responsibility e o valor do boleto caso seja anual
          modelBoleto.valorNominal = parseFloat(this.company.responsibility).toFixed(2)
          modelBoleto.mensagem = 'Boleto referente ao plano empresarial'        
          modelBoleto.nsu = this.company.proposalNumber
          modelBoleto.nossoNumero = parseInt(this.company.proposalNumber +Math.floor(10 + Math.random() * 99))
          modelBoleto.seuNumero = this.company.proposalNumber +Math.floor(10 + Math.random() * 99)
          
          //Gerando o Boleto e pegando o ID
          try {
            let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
            if (res.data != '') {
              this.idBoleto = res.data.id
              this.imprimirBoleto()
            }
          } catch (error) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar Boleto, tente novamente!","ERRO");
            this.close()
          }
        } else {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#F9A825","Para gerar o boleto, é necessário assinar o contrato!","ATENÇÃO");
        }
      },

      async aceiteProposta() {
        if (this.contrataccept) {
          await this.pegaDadosConfirmacao()
          try {
            this.isLoading = true
            let envio = {
              "salesmanIPConfirm": this.ipConfirm,
              "companyIPConfirm": this.ipConfirm,
              "salesmanConfirm": this.confirmDate,
              "companyConfirm": this.confirmDate,
              "status": "EM VALIDAÇÃO"
            }
            await axios.post(`${baseApiUrl}Companies/upsertWithWhere?[where][id]=${this.company.id}`, envio)
            .then(() => {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#51D400","Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à Odontobase a dar andamento na proposta ao Contrato Coletivo Empresarial.","Proposta confirmada com Sucesso!") 
            })
            .catch(() => {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825","Você pode tentar confirmar novamente ou entrar em contato com a Odontobase.","Algo deu errado na confirmação da proposta!")
            })
          } catch (error) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao aceitar proposta. Por favor, tente novamente","ATENÇÃO")
          }
        } else {
          this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Para aceitar a proposta, é necessário assinar o contrato!","ATENÇÃO");
        }
      },

      async pegaDadosConfirmacao() {
        //coleta IP, data e hora da confirmação do cliente    
        try {
          let res = await axios.get(`https://api.ipify.org/?format=json`)
          if (res.data != null) {
            this.ipConfirm = res.data.ip
          } else {
            this.ipConfirm = '127.0.0.0'
          }
        } catch (error) {
          this.ipConfirm = '127.0.0.0'
        }
        this.confirmDate = new Date().toISOString()
      },
        
      async imprimirBoleto() {
        this.isLoading = true
        await this.pegaDadosConfirmacao()
        //Baixando Boleto PDF
        try {
          let res = await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.idBoleto}/imprimir`,{ responseType: 'arraybuffer', headers: {
              Authorization: 'Bearer ' + this.token, //the token is a variable which holds the token
              'Content-type': 'application/pdf'
            }
          })
          if (res.data != null) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [res.data], 
              {type: 'application/pdf'}
            );
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute('download', 'boleto.pdf'); //or any other extension
            document.body.appendChild(link);
            link.click();
            //Open the URL on new Window
            window.open(fileURL);
            if (!this.boletoGerado) {
              this.boletoGerado = true
              this.msmTitulo = 'Proposta confirmada com Sucesso!'
              this.msgCorpo = 'Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à Odontobase a dar andamento na proposta ao Contrato Coletivo Empresarial.'
              this.atualizaCompany()
            } else {
              this.imprimir = false
              this.msmTitulo = 'Boleto impresso com Sucesso!'
              this.msgCorpo = 'Com a confirmação dos dados da empresa, bem como dos colaboradores, após o pagamento do boleto, fica autorizado à Odontobase a dar andamento na proposta ao Contrato Coletivo Empresarial.'  
            }
            this.isLoading = false 
          }              
        } catch (error) {
          this.isLoading = false
          var vm = this;            
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao imprimir Boleto, tente novamente ou entre em contato com a Odontobase!","ERRO");
          this.close()
        }
      },

      async pegaParametrosUrl(){
        var params = window.location.search.substring(1).split('?');
        if (params[0] != '') {
          //Criar objeto que vai conter os parametros
          var paramArray = {};
          //Passar por todos os parametros
          for (var i=0; i<params.length; i++) {
            //Dividir os parametros chave e valor
            var param = params[i].split('=');
            //Adicionar ao objeto criado antes
            paramArray[param[0]] = param[1];
          }
          if (paramArray['cp']) {   
            await axios.get(`${baseApiUrl}Companies?filter[where][id]=${paramArray['cp']}`)
            .then(async res => { 
              if (res.data != null) {
                this.company = res.data[0]
                if (this.company.situacaoBoleto == "" || this.company.situacaoBoleto == "VENCIDO" || this.company.situacaoBoleto == undefined) { 
                  this.retornoViaCEP()
                  this.confirmado = true 
                } else if(this.company.situacaoBoleto == "PAGO") {
                  this.confirmado = true
                  this.boletoGerado = true
                  this.msmTitulo = 'Pagamento detectado!'
                  this.msgCorpo = 'Olá, detectamos que você já efetuou o pagamento do boleto, entre em contato com a Odontobase para mais informações.'
                } else if(this.company.situacaoBoleto == "BAIXADO") {
                  this.confirmado = true
                  this.boletoGerado = true
                  this.msmTitulo = 'Boleto Baixado!'
                  this.msgCorpo = 'Olá, O boleto para essa proposta encontra-se baixado, para mais informações entre em contato com a Odontobase.'
                } else if(this.company.situacaoBoleto == "REGISTRADO" || this.company.situacaoBoleto == "GERADO") {
                  this.msmTitulo = 'Boleto disponível!'
                  this.msgCorpo = 'Olá, já existe um boleto gerado para a sua proposta, clique abaixo para imprimir.'
                  this.confirmado = true
                  this.imprimir = true
                  this.boletoGerado = true
                  this.idBoleto = this.company.boletoId
                  //this.imprimirBoleto()
                }
              }
              this.carregaPlano()

              await this.gerarContratoZapSign()
            })
            .catch(() => {
              this.confirmado = false
              this.msmTitulo = 'Algo deu errado na confirmação da proposta!'
              this.msgCorpo = 'Você pode tentar confirmar novamente ou entrar em contato com a Odontobase.'
            })
          }
        }
      },

      async gerarContratoZapSign() {
        this.modoAssinatura = 'ZAPSIGN'

        if (!this.company.ZSLinkAssinatura) {
          await axios.post(baseApiUrl + 'ServiceZapSign/criaDocumentoPJ', {"companyId": this.company.id})
          .then(async response => {
            if (response.data) {
              this.company.ZSLinkAssinatura = response.data.sign_url
              this.company.ZSTokenDocumento = response.data.token
              
              this.consultaAssinaturaZapSign()
            }
          })
          .catch(() => {
            this.modoAssinatura = 'CHECKBOX'
          })
        } else if (this.company.ZSLinkAssinatura && (this.company.ZSContratoAssinado || !this.company.ZSContratoAssinado)) {
          this.consultaAssinaturaZapSign()
        } else {
          this.modoAssinatura = 'CHECKBOX'
        }
      },

      async consultaAssinaturaZapSign() {
        try {
          this.verificaAssinatura = setInterval(
            async function () {
              await axios.get(baseApiUrl + 'Companies/' + this.company.id)
              .then(response => {
                if (response.data.ZSContratoAssinado) {
                  this.contrataccept = true
                  this.company = response.data
                  clearInterval(this.verificaAssinatura);
                }
              });
            }.bind(this), 5000);
        } catch (error) {
          clearInterval(this.verificaAssinatura);
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar a assinatura do contrato, tente novamente!", "DESCULPE");
        }
      },

      async atualizaCompany() {
        let envio = {
          "salesmanIPConfirm": this.ipConfirm,
          "companyIPConfirm": this.ipConfirm,
          "salesmanConfirm": this.confirmDate,
          "companyConfirm": this.confirmDate,
          "boletoId": this.idBoleto,
          "situacaoBoleto": "GERADO",
          "nossoNumero": modelBoleto.nossoNumero,
          "status": "AGUARDANDO PAGAMENTO"
        }
        try {
          await axios.post(`${baseApiUrl}Companies/update?[where][id]=${this.company.id}`, envio)
        } catch (error) {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao atualizar situação do boleto e empresa, tente novamente","ATENÇÃO")
        }
      },

      async retornoViaCEP() {
        if (this.company.cep != '') {
          try {
            let res = await axios.get(`https://viacep.com.br/ws/${this.company.cep.replace(/[^\d]+/g,'')}/json/`) 
            if (res.data != '') {
              this.cidade = res.data.localidade
              this.estado = res.data.uf
              this.bairro = res.data.bairro
              if(!this.cidade || !this.estado || !this.bairro || (res.data.erro && res.data.erro.toString() == 'true'))
                this.retornoCEP()
            } else {
              var vmcep = this;
              vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
              this.cidade = ''
              this.estado = ''
              this.bairro = ''
            }
          } catch (error) {
            // vmcep = this;
            // vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
            this.cidade = ''
            this.estado = ''
            this.bairro = ''
            await this.retornoCEP()
          }
        }        
      },

      async retornoCEP() {
        try {
          let res = await axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.company.cep}) 
          if (res.data != '') {
            await axios.get(`${baseApiUrl}UFs?filter={"where":{"codeS4":${res.data.IdUf}}}`).then(res2 => {
              this.estado = res2.data[0].prefix
              this.cidade = res.data.Municipio
              this.bairro = res.data.Bairro
            })
          }
        } catch (error) {
          var vmcep = this;
          vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
        }         
      },

      async verificaVersao() {
        await axios.get(`${baseApiUrl}Operadoras/versao`).then(res => {
          if (res.data != null) {
            //console.log("Versão no servidor: ", res.data.versao)
            if (!localStorage.getItem('versao')) {
              //console.log("Sem versão ou com versão: ", localStorage.getItem('versao'))
              localStorage.setItem('versao', res.data.versao)
            } else {
              if (localStorage.getItem('versao') != res.data.versao) {
                //console.log("Com versão, porem antiga. Alterando...")
                localStorage.setItem('versao', res.data.versao)
                window.location.reload(true)
              }
            }
          }
        })
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date;
      },
    }
  }
</script>

<style>
  .link {
    font-size: 1.3rem;
    color: #194383;
    text-align: center;
  }

  .titulo {
    font-size: 2rem;
    color: #797a7a;
    text-align: center;
  }

  .imagemcaarj {
    background: url('https://www.apvs.com.br/assets/uploads/parceiros/caarj.png')no-repeat;
    background-size: 500px;
  }
</style>